/* istanbul ignore file */
import React from 'react';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import useProjectStatusesService from 'domain/projects/project/statuses/ProjectStatusesService';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import ProjectPlanningStatusForm from 'domain/projects/project/statuses/planning/form/ProjectPlanningStatusForm';

interface UpdateProjectPlanningStatusFormProps extends UpdateFormProps {
  onCancel: () => void;
}

const UpdateProjectPlanningStatusForm = ({ getDataFunc, onCancel, ...props }: UpdateProjectPlanningStatusFormProps) => {
  const { getDemoValidationSchema, update } = useProjectStatusesService();

  return (
    <UpdateForm
      {...props}
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getDemoValidationSchema}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <ProjectPlanningStatusForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateProjectPlanningStatusForm;
